import { Box, BoxProps, ColorOptions, convertHexToRGBA, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { Linking, Platform, ViewProps } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import Carousal from '../../comps/Carousal'
import { ChatbotButton } from '../../comps/Chatbot'
import EmptyView from '../../comps/EmptyView'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Colors, isOsMobile, logEvent } from '../../util/util'
import { Accordion } from './Accordion'

const scrollThreshold = 2

const Support: FC = () => {
  const { merchantName, getVideoList, getVideos } = useStores((store) => ({
    merchantName: store?.settings?.metaData?.selectedMercName,
    getVideos: store.settings.metaData.getVideos,
    getVideoList: store.settings.metaData.getVideoList,
  }))
  const [getVideo, { state }] = useLazyApiData(getVideos)
  const listData = getVideoList()
  const { showChatbotAwareness = false }: any = useRoute()?.params ?? {}
  useEffect(() => {
    if (listData?.length === 0 && isOsMobile()) {
      getVideo()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [helpTopics, setHelpTopics]: any = useState(helpTopicsData())
  const [selectedTopic, setSelectedTopics]: any = useState(helpTopicsData()?.[0].key)
  const [scrollPos, setScrollPos]: any = useState({ x: 0, y: 0 })
  const [shrink, setShrink]: any = useState(false)
  const navigation = useNavigation()

  const params = useRoute()?.params ?? {}
  const { header }: any = params

  const headerLeft = () => {
    return (
      <Box backgroundColor={'TRANSPARENT'} flexDirection="row" justifyContent="center" alignItems={'center'} h={64}>
        <ModBox
          paddingLeft={25}
          paddingRight={10}
          top={Platform.OS === 'ios' ? -30 : 0}
          show={navigation?.canGoBack()}
          underlayColor={'TRANSPARENT'}
          testID="back-arrow"
          onPress={() => navigation?.goBack()}>
          <SvgImage imageName="HeaderArrowLeft" />
        </ModBox>
      </Box>
    )
  }

  navigation.setOptions({
    title: header,
    headerTintColor: '#fff',
    headerBackVisible: true,
    headerShadowVisible: false,
    headerLeft: Platform.OS === 'ios' ? headerLeft : () => <HeaderLeft />,
    headerStyle: { backgroundColor: Colors.SECONDARY },
    headerTitleStyle: {
      fontSize: 16,
      fontFamily: 'JioType-Bold',
      top: Platform.OS === 'ios' ? -30 : 0,
    },
  })

  const handleHelpTipc = (item: any) => {
    logEvent('btn_press', `${item.title}_help_topic`)
    const filtered = helpTopics?.map((ele: any) => {
      if (ele.title === item.title) {
        setSelectedTopics(ele.key)
        return { ...ele, selected: true }
      } else {
        return { ...ele, selected: false }
      }
    })
    setHelpTopics(filtered)
  }

  const mail = () => {
    Linking.openURL('mailto:merchant.support@jiopay.in')
  }

  const handleNavigation = (item: any) => {
    navigation.navigate('video' as never, { url: item.videoUrl } as never)
  }

  const handleScroll = ({ x, y }: any) => {
    setScrollPos(() => {
      if (y > scrollThreshold) {
        const sScrollingUp = y < scrollPos?.y
        setShrink(sScrollingUp ? false : true)
      } else {
        setShrink(false)
      }

      return { x, y }
    })
  }

  return (
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'}>
      <ScrollView
        scrollEventThrottle={5000}
        onScroll={({ nativeEvent: { contentOffset } }) => handleScroll(contentOffset)}
        style={{ backgroundColor: '#fff', ...styles.listWrapper }}
        showsVerticalScrollIndicator={false}>
        <Box ph={24}>
          <Spacer size={20} direction="vertical" />
          <Text fontFamily={'JioType-Black'} fontSize={24} color={Colors.BLACK_14 as ColorOptions}>
            Hello {merchantName},
          </Text>
          <Text fontFamily={'JioType-Black'} fontSize={24} color={Colors.BLACK_14 as ColorOptions}>
            How can we help you?
          </Text>

          <Spacer size={30} direction="vertical" />
          <Text fontFamily={'JioType-Black'} fontSize={18} color={Colors.BLACK_14 as ColorOptions}>
            Help Topics
          </Text>
          <Spacer size={10} direction="vertical" />
          <Box>
            <Box
              flexDirection={'row'}
              minHeight={45}
              bg={'WHITE'}
              flexWrap={'wrap'}
              justifyContent="flex-start"
              pv={10}>
              {helpTopics?.map((item: any, index: number) => (
                <Box
                  {...styles.helpTopicsWrapper}
                  underlayColor="TRANSPARENT"
                  disabled={item.selected}
                  key={index}
                  testID="help-topics"
                  onPress={() => handleHelpTipc(item)}>
                  <Box {...styles.helpTopics(item.selected)}>
                    <SvgImage
                      imageName={item.icon}
                      width={24}
                      height={24}
                      color={item.selected ? '#fff' : Colors.SECONDARY}
                    />
                  </Box>
                  <Text textAlign="center" fontSize={12} fontFamily={'JioType-Medium'} fontWeight="FONT_WEIGHT_MEDIUM">
                    {item.title}
                  </Text>
                </Box>
              ))}
            </Box>
            <Spacer size={24} direction="vertical" />
            <Text fontFamily={'JioType-Black'} fontSize={18} color={Colors.BLACK_14 as ColorOptions}>
              Frequently Asked Questions
            </Text>
            <Spacer size={10} direction="vertical" />
            <Accordion type={selectedTopic} />
          </Box>
          <Spacer size={40} direction="vertical" />
        </Box>

        <ModBox show={isOsMobile()} ph={24}>
          <Text fontFamily={'JioType-Black'} fontSize={18} color={Colors.BLACK_14 as ColorOptions}>
            How to Videos
          </Text>
          <Spacer size={20} direction="vertical" />
          <ModBox
            height={60}
            pb={15}
            show={state === 'pending' || state === 'rejected'}
            bg={'BACKGROUND' as ColorOptions}
            alignItems="center"
            justifyContent="center">
            <EmptyView
              onRetry={() => {
                getVideo()
              }}
              isLoading={state === 'pending'}
              error={state === 'rejected'}
              loadingMessage=""
              emptyMessage=""
            />
          </ModBox>
        </ModBox>
        <ModBox show={listData?.length > 0} {...styles.carousalContainer}>
          {listData?.length > 0 && (
            <Carousal data={listData} isSnapEnabled onPress={handleNavigation} isFromProfile={false} />
          )}
        </ModBox>
        <Spacer size={20} direction="vertical" />
        <Box
          underlayColor={'TRANSPARENT'}
          testID="mail-to"
          onPress={mail}
          bg={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}
          borderRadius={10}
          p={20}
          marginHorizontal={24}
          flexDirection="row"
          alignItems={'flex-start'}>
          <Box w={35} h={35} bg={Colors.PRIMARY} borderRadius={35} justify="center" align="center">
            <SvgImage imageName="MailIcon" />
          </Box>
          <Spacer size={10} direction="horizontal" />
          <Box>
            <Text fontFamily={'JioType-Bold'} lineHeight={20} fontSize={14} color={Colors.BLACK_14 as ColorOptions}>
              Email Us
            </Text>
            <Spacer size={2} direction="vertical" />
            <Text
              numberOfLines={3}
              color={'#757575' as ColorOptions}
              fontSize={12}
              lineHeight={16}
              fontFamily={'JioType-Medium'}>
              {"Tell us little about your issues and\nwe'll email you back"}
            </Text>
          </Box>
        </Box>
        <Spacer size={140} direction="vertical" />
      </ScrollView>
      <ModBox show={Platform.OS === 'android'}>
        <ChatbotButton showChatbotAwareness={showChatbotAwareness} shrink={shrink} />
      </ModBox>
    </Box>
  )
}

const helpTopicsData = () => {
  const list = [
    {
      icon: 'MyAccountIcon',
      title: 'My Account',
      key: 'MyAccount',
      selected: true,
    },
    {
      icon: 'BankIcon',
      title: 'Settlements',
      key: 'Settlement',
      selected: false,
    },
    {
      icon: 'RupeeIconFilled',
      title: 'Transactions',
      key: 'Transaction',
      selected: false,
    },
    {
      icon: 'RefundIcon',
      title: 'Refunds',
      key: 'Refunds',
      selected: false,
    },
  ]

  if (isOsMobile()) {
    list.push({
      icon: 'BillPaymentRupeeIcon',
      title: 'Bill Payments',
      key: 'BillPayments',
      selected: false,
    })
  }
  return list
}

const styles = {
  listWrapper: {
    backgroundColor: '#fff',
    pv: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    width: '100%',
    zIndex: 4,
  } as ViewProps,
  helpTopics: (selected: boolean) =>
    ({
      width: 48,
      height: 48,
      borderRadius: 48,
      bg: selected ? Colors.PRIMARY : (convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions),
      alignItems: 'center',
      justifyContent: 'center',
      mb: 10,
    } as BoxProps),
  helpTopicsWrapper: {
    alignItems: 'center',
    width: '25%',
    marginBottom: 16,
  } as BoxProps,
  carousalContainer: {
    height: 180,
  } as BoxProps,
}

export default Support
